module.exports = function() {
	return new Worker(__webpack_public_path__ + "8326e76ae84e026da11a.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/worker-loader!./src/worker.js
 ** module id = 2
 ** module chunks = 1
 **/